/**
 * Base and authentication endpoints
 * */

/*Base*/
export const API_URL = "https://api.nicholaslyz.com";
export const FILES_URL = "https://files.nicholaslyz.com";
